import WeightedEdge from './WeightedEdge';
import DataFlowEdge from './DataFlowEdge';
import RelationshipEdge from './RelationshipEdge';

export const edgeTypes = {
  weighted: WeightedEdge,
  dataFlow: DataFlowEdge,
  relationship: RelationshipEdge,
};
